<template>
  <v-container>
    <v-tabs v-model="activeTab">
      <v-tab v-for="(dept, index) in departments" :key="index">
        {{ dept.name }}
      </v-tab>
    </v-tabs>
    <!-- Tab content -->
    <v-window v-model="activeTab">
      <v-window-item v-for="(dept, index) in departments" :key="index">
        <v-card class="mt-4" flat>
          <v-row>
            <progressHelper
              :progressKey="dept.progressKey"
              @finish="progressFinished"
            ></progressHelper>
          </v-row>
          <v-row v-show="!hiddenRowsTab.includes(index)">
            <v-col cols="auto">
              <v-dialog max-width="600">
                <template v-slot:activator="{ props: activatorProps }">
                  <v-btn icon variant="text" v-bind="activatorProps"
                    ><v-icon color="warning">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <template v-slot:default="{ isActive }">
                  <v-card title="О версиях тарификации">
                    <v-card-text>
                      <dl>
                        <dt>Создание версии тарификации</dt>
                        <dd>
                          Версия тарификации создаётся на весь учебный год
                        </dd>
                        <dd>
                          Флажок "Версия тарификации на следующий учебный год" позволяет отобразить дисциплины следующего учебного года 
                          и устанавливается перед добавлением версии.
                        </dd>
                        <dt>При утверждении версии тарификации</dt>
                        <dd>
                          Студенты и преподаватели автоматически записываются на
                          электронные курсы согласно тарификации
                        </dd>
                        <dd>
                          Удаление пользователей с курсов при этом не
                          производится
                        </dd>
                        <dt>
                          После внесения изменений в тарификацию необходимо
                          повторно утвердить версию, чтобы изменения вступили в
                          силу
                        </dt>
                      </dl>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        text="Закрыть"
                        @click="isActive.value = false"
                      ></v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </v-col>
            <!-- datepicker -->
            <v-col cols="12" md="6">
              <datepicker v-model="dept.newDate"></datepicker>
            </v-col>
            <v-col cols="auto" class="d-flex align-center">
              <v-btn
                @click="addDate(index)"
                :disabled="!dept.newDate"
                color="primary"
              >
                Добавить
              </v-btn>
            </v-col>
          </v-row>

          <v-row v-show="!hiddenRowsTab.includes(index)">
            <v-col cols="12">
              <v-checkbox
                color="primary"
                v-model="dept.nextYear"
                class="myСheckbox"
                label="Версия тарификации на следующий учебный год"
              />
            </v-col>
          </v-row>
          <!-- Список версий -->
          <v-list v-show="!hiddenRowsTab.includes(index)">
            <v-list-item
              v-for="(data, i) in dept.version"
              :key="i"
              class="border-list-item"
            >
              <v-row justify="space-between" no-gutters>
                <v-col class="d-flex align-center" cols="auto">
                  <span class="mr-4"
                    >{{ "Версия " + data.date + " " }}
                    <span style="color: goldenrod">
                      {{
                        data.next_year == true ? " (на след. учебный год) " : ""
                      }}
                    </span>
                    <span style="color: forestgreen">
                      {{ data.approved == true ? "текущая версия" : "" }}
                    </span>
                  </span>
                  <v-btn
                    icon
                    :disabled="dept.current === data.id"
                    :title="
                      dept.current != data.id ? 'Утвердить тарификацию' : ''
                    "
                    @click="approveVersionPrompt(index, data)"
                    variant="text"
                  >
                    <v-icon
                      :color="
                        dept.current === data.id
                          ? 'light-green-accent-4'
                          : 'green-lighten-2'
                      "
                      >{{
                        dept.current === data.id
                          ? "mdi-check-decagram"
                          : "mdi-note-check-outline"
                      }}</v-icon
                    >
                  </v-btn>
                </v-col>
                <v-col class="d-flex justify-end" cols="auto">
                  <v-btn
                    icon
                    @click="deleteDialog(index, i)"
                    title="Удалить версию тарификации"
                    variant="text"
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>

          <v-overlay
            v-model="processData"
            persistent
            class="align-center justify-center"
          >
            <v-progress-circular
              color="primary"
              size="64"
              indeterminate
            ></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-window-item>
    </v-window>

    <!-- Диалог подтверждения удаления -->
    <v-dialog v-model="confirmDialog.show" max-width="600">
      <v-card>
        <v-card-title class="text-h6">Подтвердите удаление</v-card-title>
        <v-card-text>
          Вы уверены, что хотите удалить версию тарификации от
          <strong>{{ confirmDialog.version?.date }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDialog.show = false">Отмена</v-btn>
          <v-btn color="red" text @click="removeVersion">Удалить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Диалог подтверждения утверждения -->
    <v-dialog v-model="approveDialog.show" max-width="500">
      <v-card>
        <v-card-title class="text-h6"> Подтверждение утверждения </v-card-title>
        <v-card-text>
          Вы уверены, что хотите утвердить версию тарификации от
          <strong>{{ approveDialog.version?.date }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="approveDialog.show = false">Отмена</v-btn>
          <v-btn color="green" text @click="confirmApprove">Утвердить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Подсказка-->
  </v-container>
</template>
<script>
import datepicker from "moodleDir/procollege/lib/vue/datepicker.vue";
import progressHelper from "moodleDir/procollege/lib/vue/ProgressHelper.vue";
export default {
  data() {
    return {
      activeTab: 0,
      departments: [],
      processData: false,
      hiddenRowsTab: [],
      confirmDialog: {
        show: false,
        deptIndex: null,
        dateIndex: null,
        version: null,
      },
      approveDialog: {
        show: false,
        deptIndex: null,
        version: null,
      },
    };
  },
  components: {
    datepicker,
    progressHelper,
  },
  created() {
    this.fetchVersions();
  },
  methods: {
    fetchVersions() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/tariffication/versionTariffication/getVersions",
          new URLSearchParams({
            page: document.location.pathname + document.location.hash,
          })
        )
        .then((resp) => {
          for (let i in resp.data) {
            const newItem = {
              ...resp.data[i],
              id: i,
              newDate: null,
              current: null,
              nextYear: false,
            };
            this.departments.push(newItem);
          }

          for (let i in this.departments) {
            if (this.departments[i].progressKey) {
              this.hiddenRows(i);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    hiddenRows(deptIndex) {
      const idx = this.hiddenRowsTab.indexOf(deptIndex);
      if (idx === -1) {
        this.hiddenRowsTab.push(Number(deptIndex));
      }
    },

    addDate(index) {
      const dept = this.departments[index];
      const date = dept.newDate;
      for (let i in dept.version) {
        if (dept.version[i].date.includes(date)) {
          return;
        }
      }
      this.processData = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/tariffication/versionTariffication/addVersion",
          new URLSearchParams({
            departmentid: dept.id,
            date: date,
            nextYear: dept.nextYear,
          })
        )
        .then((response) => {
          dept.version.push({
            id: response.data,
            date: date,
            approved: null,
            next_year: dept.nextYear,
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.processData = false;
        });
    },
    deleteDialog(deptIndex, dateIndex) {
      const dept = this.departments[deptIndex];
      const version = dept.version[dateIndex];
      this.confirmDialog = {
        show: true,
        deptIndex,
        dateIndex,
        version,
      };
    },
    removeVersion() {
      this.processData = true;
      const { deptIndex, dateIndex, version } = this.confirmDialog;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/tariffication/versionTariffication/deleteVersion",
          new URLSearchParams({
            versionid: version.id,
          })
        )
        .then(() => {
          const dept = this.departments[deptIndex];
          dept.version.splice(dateIndex, 1);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.confirmDialog.show = false;
          this.processData = false;
        });
    },
    approveVersionPrompt(deptIndex, version) {
      this.approveDialog = {
        show: true,
        deptIndex,
        version,
      };
    },

    async confirmApprove() {
      this.approveDialog.show = false;
      this.processData = true;
      const { deptIndex, version } = this.approveDialog;
      const dept = this.departments[deptIndex];
      this.hiddenRows(deptIndex);

      let formData = new FormData();
      formData.append(
        "page",
        document.location.pathname + document.location.hash
      );
      formData.append("versionid", version.id);
      formData.append("departmentid", dept.id);
      await this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/tariffication/versionTariffication/approveVersion",
          formData
        )
        .then((response) => {
          dept.progressKey = response.data;
          dept.progressVersion = version.id;
        })
        .finally(() => {
          this.processData = false;
        });
    },

    progressFinished(key) {
      for (let i in this.departments) {
        const dept = this.departments[i];
        if (dept.progressKey === key) {
          dept.progressKey = null;
          dept.version.forEach((v) => {
            v.approved = v.id == dept.progressVersion;
          });
          dept.current = dept.progressVersion;

          const idx = this.hiddenRowsTab.indexOf(Number(i));
          if (idx !== -1) {
            this.hiddenRowsTab.splice(idx, 1);
          }
        }
      }
    },
  },
};
</script>

<style>
.myСheckbox .text-success {
  font-size: inherit !important;
}
.myСheckbox .v-label {
  margin-bottom: 0 !important;
}
.border-list-item {
  border-bottom: 1px solid #ccc;
}
</style>